<template>
    <div>
        <my-form 
        class="form-page" 
        v-model="form" 
        table 
        v-if="show"
        label-width="180px">
            <el-form-item
            class="table-full-row"
            label="已经选择的项目助理">
                <my-checkbox
                model-str
                str-spliter=";"
                v-model="rylist"
                :data="selectList"
                :props="{label:'name',value:'id'}">
                </my-checkbox>
            </el-form-item>
            <el-form-item
            class="table-full-row"
            label="可选择的项目助理">
                <my-select
                    v-model="form.id"
                    :data="zlList"
                    :props="{value:'ID',label:'name'}"
                    2way="name"
                    style="width:50%"
                    :name.sync="form.name">
                </my-select>

                <el-button 
                size="mini" 
                icon="el-icon-plus" 
                type="primary" 
                @click="addZl"
                style="margin-left:10px">
                    添加助理
                </el-button>
            </el-form-item>

            <template slot="btn">
                <el-button 
                @click="saveHandler()" 
                type="primary" 
                icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button 
                icon="el-icon-circle-close" 
                @click="$emit('cancle')">
                    取消
                </el-button>
            </template>
        </my-form>
        <div v-if="!show">
            <my-tag type="danger">
                <p style="font-weight:600"><i class="el-icon-info"></i>提示消息</p>
                <p>此项目不是您创建的，您没有权利设置项目助理！</p>
                <p>请联系项目的创建者，进行项目助理的添加！</p>
                <p>此项目的创建者为：{{create}}</p>
            </my-tag>
        </div>
    </div>
</template>

<script>
export default {
   
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        
    },
    data: () => ({
        form: {},
        zlList:[],
        selectList:[],
        rylist:'',
        show:true,
        create:''
    }),
    computed: {
       
    },
    methods: {
        // 初始化
        formInit(){
            var that = this
            that.jspInit(`${that.getGetters('mngUrl')}/Zbdl/Project/prozhushou.json`,{
                procode:that.row.procode,
            }, data => {
                if(data.create){
                    that.show = false
                    that.create = data.create
                }else{
                    // 下拉框数据
                    data.list3.forEach(function(item){
                        item.EXTDEPTNAME = item.EXTDEPTNAME.replace(/\s+/g,"")
                        item.name = '（' + item.EXTDEPTNAME + '）' +item.TRUENAME
                    })
                    that.zlList = data.list3

                    // 与选中  多选框数据
                    var arr = []
                    data.list1.forEach(function(item){
                        item.extdeptname = item.extdeptname.replace(/\s+/g,"")
                        item.name = '（' + item.extdeptname + '）' +item.truename
                        item.id = item.id.toString()
                        arr.push(item.id)
                        
                    })
                    that.rylist = arr.join(";")
                    that.selectList = data.list1
                }
                
            })
        },
        // 选中项目经理
        addZl(){
            var that = this
            that.$post(`${that.getGetters('mngUrl')}/Zbdl/Project/addzhushou.json`,{
                procode:that.row.procode,
                id:that.form.id
            }, data => {
                that.form.id = that.form.id.toString()
                that.selectList.push(that.form);
                var arr = that.rylist.split(';');
                arr.push(that.form.id);
                that.rylist = arr.join(";");
                that.form = {}
                that.formInit();
            })
        },
        // 保存
        saveHandler(type, cb){
            var that = this
            if(!that.rylist){
                ShowMsg('请勾选项目助理','warning');
                return;
            }
            that.$post(`${that.getGetters('mngUrl')}/Zbdl/Project/zhushou.json`,{
                procode:that.row.procode,
                rylist:that.rylist
            }, data => {
                ShowMsg('设置项目助理成功','success');
                that.$emit('cancle')
            })
        },
    },
    created() {
        this.formInit()
       
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

/deep/ .form-page{ width: 100%;}
/deep/ .el-tag{ width: 98%; padding: 1%;}
/deep/ .el-tag p{ font-size: 22px; line-height: 40px;}
</style>
